'use strict';
/* for groups, we do not really know the size before doing the layout
 * because the layout calculator will expand the group based on the
 * size and position of child bubbles. so the actual area relevant
 * for links and connectors needs to be taken from the layout for groups,
 * but from node metrics for other nodes
 */
module.exports = function bubbleRect(nodeFromMapLayout, nodeView) {
	const nodeMetrics = nodeView.metrics,
		rectFromMetrics = Object.freeze({
			top: nodeMetrics.bubble.y + nodeFromMapLayout.y,
			left: nodeMetrics.bubble.x + nodeFromMapLayout.x,
			width: nodeMetrics.bubble.width,
			height: nodeMetrics.bubble.height
		}),
		rectFromMapLayout = Object.freeze({
			top: nodeFromMapLayout.y,
			left: nodeFromMapLayout.x,
			width: nodeFromMapLayout.width,
			height: nodeFromMapLayout.height
		});
	return nodeView.isGroup ? rectFromMapLayout : rectFromMetrics;
};

